import React, { Component } from 'react';
import { Checkbox } from 'primereact/checkbox';

import { RelatedEntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import GrupoPermissao from '../../../models/GrupoPermissao';
import Grupo         from '../../../models/Grupo';
import Permissao     from '../../../models/Permissao';

// ─── Esquema de campos ────────────────────────────────────────────────────────

export const model = {
    id: {
        exibir:  "main.id",
        visivel: true,
        tipo:    'numeric',
        largura: "5rem",
        fixar:   true
    },
    grupo: {
        exibir:       'main.grupopermissao.grupo',
        visivel:      true,
        tipo:         'relacao',
        entidade:     'grupo.entidade',
        template:     'grupo.template',
        camporelacao: 'nome',
        validacao:    { obrigatorio: true }
    },
    permissao: {
        exibir:       'main.grupopermissao.permissao',
        visivel:      true,
        tipo:         'relacao',
        entidade:     'permissao.entidade',
        template:     'permissao.template',
        camporelacao: 'state',
        validacao:    { obrigatorio: true }
    },
    permitido: {
        exibir:   'main.grupopermissao.permitido',
        visivel:  true,
        tipo:     'boolean',
        template: 'permitido.template',
    },
    updatedAt: {
        exibir:  "main.updatedAt",
        largura: '10rem',
        tipo:    'date',
        time:    true
    },
    createdAt: {
        exibir:  "main.createdAt",
        largura: '10rem',
        tipo:    'date',
        time:    true
    },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

export const renderers = {
    grupo:     { entidade: Grupo,     template: (rowData) => rowData.grupo?.nome      || rowData.grupo?.id     || '' },
    permissao: { entidade: Permissao, template: (rowData) => rowData.permissao?.state || rowData.permissao?.id || '' },
    permitido: {
        template: (rowData) => (
            <i className={`pi ${rowData.permitido ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
        )
    },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

export class GrupoPermissaoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        const updateBool = (campo, valor) => contexto.updateModelPath(campo + '.value', valor);

        return (
            <>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.grupo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.permissao} contexto={contexto} />
                </div>
                <div className="field col-12 mt-3 flex align-items-center gap-2">
                    <Checkbox
                        inputId="permitido"
                        checked={!!model.permitido?.value}
                        onChange={(e) => updateBool('permitido', e.checked)}
                        disabled={model.permitido?.readonly}
                    />
                    <label htmlFor="permitido">{contexto.traduzir('main.grupopermissao.permitido')}</label>
                </div>
            </>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class GrupoPermissaoTemplate extends Component {

    render() {
        return (
            <RelatedEntityGrid
                entidade={GrupoPermissao}
                model={model}
                identidade="main.grupopermissao"
                icone="pi-shield"
                storageKey="dt-grupopermissoes"
                permissoes={this.props.permissoes}
                processos={[]}
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                formulario={(m, ctx) => <GrupoPermissaoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default GrupoPermissaoTemplate;
